import { request } from '/@/axios/request'

// 获取授权（Index/getAuthInfo）
export function getAuth(params, options) {
  return request('https://auth.date163.com/index/getAuthInfo', params, options, 'get')
}

// 获取授权网站插件列表
export function getAuthPluginList(params, options) {
  return request('https://auth.date163.com/plugin/getList', {
    ...params,
    orderBy: 'id',
    orderType: 'desc'
  }, options, 'get')
}

// 获取授权网站插件详情
export function getAuthPluginDetail(params, options) {
  return request('https://auth.date163.com/plugin/getOne', params, options, 'get')
}

// 获取最新版本号
export function getLatestVersion(params, options) {
  return request('https://auth.date163.com/index/getLatestVersion', params, options, 'get')
}

// 获取版本列表
export function getVersionList(params, options) {
  return request('https://auth.date163.com/index/getVersionList', params, options, 'get')
}

// 提交授权申请（原有接口，保留）
export function submitAuthApply(params, options) {
  return request('https://auth.date163.com/auth/apply/submit', params, options, 'post')
}

// ===== 新增：与 Auth.php 直接交互的接口 =====

// 保存授权信息（Auth/save）——修改授权时调用
export function saveAuth(params, options) {
  return request('https://auth.date163.com/auth/save', params, options, 'post')
}

// 获取授权备注列表（Auth/getAuthRemark）——用于判断是否已修改过授权
export function getAuthRemark(params, options) {
  return request('https://auth.date163.com/auth/getAuthRemark', params, options, 'get')
}

// 保存授权备注（Auth/saveAuthRemark）——每次修改授权后写入“修改授权”记录
export function saveAuthRemark(params, options) {
  return request('https://auth.date163.com/auth/saveAuthRemark', params, options, 'post')
}

// 授权码激活（AuthCode/codeActivate）
export function activateAuthCode(params, options) {
  return request('https://auth.date163.com/auth/codeActivate', params, options, 'post')
}
